import * as React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';


import './_cards.scss';

import {A} from '@atoms/LinksAndButtons/A';
import { HeadlineFont, HeadlineLevel, LinkStyle, Margin } from 'features/ui/enums';
import {P} from '@atoms/Text/P';
import {Icon} from '@atoms/Media/Icon';
import {ResidenceTags} from '@atoms/Tags/ResidenceTags';
import {getFormattedMessage} from "features/services/utils/language-helper";
import {Headline} from '@atoms/Text/Headline';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic table row data
    errand: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic event handler
    onCardClick?: (e: any) => void;
}

export const ErrandsCard: React.FunctionComponent<Props> = ({errand, onCardClick}) => {

    const classes = classnames('grid-table__card', {
        'grid-table__card--with-tag': errand.caseStatusId,
    });
    const renderDate = (value: string) => {
        return new Date(value).toLocaleDateString();
    };

    return(
        <div className={classes}>
            {errand.caseStatusId && <ResidenceTags errandStatus={errand.caseStatusId} />}
            <P margin={Margin.S}>
                {renderDate(errand.creationDate)}
            </P>
            <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF}>{errand.room ? errand.room : '-'}</Headline>
            <dl>
                <dt><FormattedMessage id="jm.features.errands.errandsListCustomer.errandsTableCustomer.columnSpaceDetailed" /></dt>
                <dd>{errand.assetType ? errand.assetType : '-'}</dd>
                <dt><FormattedMessage id="jm.features.errands.errandsListCustomer.errandsTableCustomer.columnTicketNumber" /></dt>
                <dd>{errand.ticketNumber ? errand.ticketNumber : '-'}</dd>
                <dt><FormattedMessage id="jm.features.errands.errandsListCustomer.errandsTableCustomer.columnCaseType" /></dt>
                <dd>{errand.caseTypeName ? errand.caseTypeName : getFormattedMessage('jm.features.errands.errandsList.errandModal.caseTypeProcessing')}</dd>
            </dl>
            {onCardClick &&
                <>
                    <Icon name="arrow-link" up size={24} />
                    <A
                        href="#"
                        onClick={onCardClick}
                        route
                        variant={LinkStyle.UNSTYLED}
                        title={errand.title}
                    >
                        <span className='visually-hidden'>{errand.title}</span>
                    </A>
                </>
            }
        </div>
    )
};
